(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["component-faq"] && !window.DesignMode) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-ui-faq"] && !window.DesignMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
  var answers = document.querySelectorAll('.answer');
  var questionHeadings = document.querySelectorAll('.question-heading');

  for (var i = 0; i < answers.length; i++) {
    answers[i].style.display = 'none';
  }

  for (var i = 0; i < questionHeadings.length; i++) {
    questionHeadings[i].addEventListener('click', function() {
      var answer = this.nextElementSibling;
      answer.style.display = (answer.style.display === 'none') ? 'block' : 'none';
      this.classList.toggle('expanded');
    });
  }

  for (var i = 0; i < answers.length; i++) {
    answers[i].style.display = 'none';
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-ui-stylesheet"] && !window.DesignMode) return;
  try {
    


// Magic ATC

document.addEventListener("DOMContentLoaded",()=>{
    document.querySelectorAll('[data-pf-type="ProductATC"]').forEach(button=>{
        if (button.getAttribute("data-product.available")=="false") {
            button.innerText=button.getAttribute("data-soldout");
            return;
        }
        button.addEventListener("click",(event)=>{
            event.preventDefault();
            doATC(button);
        });
    });
});

function doATC(el) {
    el.innerText = el.getAttribute("data-adding");
    window.fetch("/cart/add.js",{
        method:"POST",
        credentials:"same-origin",
        headers:{
          "content-type":"application/json"
        },
        body:JSON.stringify({
            id:el.getAttribute("data-product-id"),
            quantity:1,
        })
    })
    .then(response=>response.json())
    .then(json=>{
        el.innerText = el.getAttribute("data-added");
        document.dispatchEvent(new CustomEvent(el.getAttribute("data-callback"),{bubbles:true}));
    });
}
  document.addEventListener("atc:gocart",()=>goCart.fetchAndOpenCart());
  document.addEventListener("atc:smartcart",()=>Rebuy.SmartCart.show());
  document.addEventListener("atc:checkout",()=>location.href="/checkout");
  document.addEventListener("atc:cartpage",()=>location.href="/cart");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav"]) return;
  try {
    
	$(document).ready(function () {
    $('.mob-heading').click(function () {
      $(this).next().slideToggle(200);
      $(this).toggleClass("expanded");
    });

    $('.mobile-child').slideUp(200);

		$(".main-title-filter").click(() => {
			$("#component-easy-search-mobile").removeClass("d-none")
				$(".main-title-filter").addClass("d-none")
			$('.mobile-sidebar').addClass("d-none")
			$('.mobile-user-nav').addClass("d-none")
			$('.mobile-search').addClass("d-none")
		})

		$(".filters-top-navigation").click(() => {
			$(".main-title-filter").removeClass("d-none")
			$("#component-easy-search-mobile").addClass("d-none")
			$('.mobile-sidebar').removeClass("d-none")
			$('.mobile-user-nav').removeClass("d-none")
			$('.mobile-search').removeClass("d-none")
		})

		$("#component-easy-search-mobile").addClass("d-none")
});

  } catch(e) { console.error(e); }
})();
})();
